import { NgClass, NgStyle } from '@angular/common';
import { Component, effect, ElementRef, inject, input, model } from '@angular/core';

@Component({
  selector: 'app-toggle-card',
  imports: [NgClass, NgStyle],
  templateUrl: './toggle-card.component.html',
  styleUrls: ['./toggle-card.component.scss'],
})
export class ToggleCardComponent {
  opened = model(false);
  title = input('');
  cardClass = input('');
  cardStyle = input({});
  bodyClass = input('');
  bodyStyle = input({});

  scrollIntoViewWhenOpened = input(false);

  private selfRef = inject<ElementRef<HTMLElement>>(ElementRef);

  constructor() {
    effect(() => {
      if (this.opened() === true && this.scrollIntoViewWhenOpened() === true) {
        // Wait for opening animation to finish
        setTimeout(() => {
          this.selfRef.nativeElement.scrollIntoView({ behavior: 'smooth' });
        }, 250);
      }
    });
  }
}
